import {omit, keyBy} from 'lodash';
import {RECEIVE_INSTITUTIONS, REMOVE_INSTITUTION} from '../actions/portfolio';
import {UPDATE_CURRENT_INSTITUTION, RECEIVE_INSTITUTION} from 'portfolio/actions/institution';

export function institutionsReducer(state = {}, action) {
  switch (action.type) {
    case RECEIVE_INSTITUTIONS:
      return {...state, ...keyBy(action.institutions, '_id')};
    case RECEIVE_INSTITUTION:
    case UPDATE_CURRENT_INSTITUTION:
      return {...state, [action.institution._id]: action.institution};
    case REMOVE_INSTITUTION:
      return omit(state, action.institutionId);
    default:
      return state;
  }
}
